class UmBack extends HTMLElement {
   constructor() {
      super();
      // this.attachShadow({ mode: 'open' });

      const btn_wrap = document.createElement('a');
      btn_wrap.setAttribute("class", `back-btn`);
      if (this.getAttribute('size')) {
        btn_wrap.setAttribute("size", this.getAttribute('size'));
      }
      this.href = this.getAttribute('href') ? this.getAttribute('href') : ''
      if (this.href) {
        btn_wrap.setAttribute("href", this.href);
      }

      const arrow = document.createElement('div');
      arrow.setAttribute("class", `custom-icon icon-arrow`);
      if (this.getAttribute('icon')) {
        arrow.setAttribute("icon", this.getAttribute('icon'));
      }

      const text = document.createElement('span');
      text.textContent = this.getAttribute('data-text');

      btn_wrap.append(text, arrow);

      // Append the button and style to the shadow root
      // this.shadowRoot.appendChild(btn_wrap);
      this.appendChild(btn_wrap);


   }

    connectedCallback() {
      this.querySelector(".back-btn").addEventListener("click", this.handleButtonClick.bind(this));
    }

    handleButtonClick(e) {
      if (!this.clickEvent) {
        return
      }
      e.preventDefault()
      if (this.clickEvent) {
        this.clickEvent()
      }

    }

}

customElements.define('um-back', UmBack);
